// Modules
import xhr from 'modules/xhr';
// API
import { ENDPOINTS } from '../api.config';
// Interfaces and types
import { IGetUnbilledHoursRes } from 'types/unbilledHoursTypes';
import { TQueryParams } from 'types/appTypes';

export const getUnbilledHours = (params: TQueryParams) => {
  return xhr.get<IGetUnbilledHoursRes, IGetUnbilledHoursRes>(`${ENDPOINTS.unbilledHours}`, {
    params,
  });
};
